import React from 'react';
import './withdraw_styles.scss';
import {
    Button,
    ButtonGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup
} from "@material-ui/core";
import axios from 'axios';
import { createApiServerRoute } from "../../../models/network/api_client";
import { connect } from 'react-redux';
import { actionSetCurrentClients } from "../../../models/redux/reducers/activity_main_reducers/clients_reducer/action_clients";
import Table from "../../../components/table_component/table/table";
import TableHeader from "../../../components/table_component/table_header/table_header";
import TableHeading from "../../../components/table_component/table_heading/table_heading";
import { API_KEY } from "../../../utils/constants";
import { withRouter } from "react-router-dom";
import TableIndexColumn from "../../../components/table_component/table_index_column/table_index_column";
import TableUserNameColumn from "../../../components/table_component/table_user_name_column/table_user_name_column";
import TableGreenishTextualColumn from "../../../components/table_component/table_greenish_textual_column/table_greenish_textual_column";
import TableTextualColumn from "../../../components/table_component/table_textual_column/table_textual_column";
import TableContainerColumn from "../../../components/table_component/table_container_column/table_container_column";
import TableBody from "../../../components/table_component/table_body/table_body";
import TableBankColumn from "../../../components/table_component/table_bank_column/table_bank_column";
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// ... imports (unchanged)

class UsersFragment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: "PENDING",
            filtered: null,
            filter: '',
            page: 1,
            totalPages: 1
        };
    }

    componentDidMount() {
        this.fetchWithdrawRequests("PENDING", 1);
    }

    fetchWithdrawRequests = (status, page = 1) => {
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY);
        params.append("status", status);
        params.append("page", page);

        const config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };

        axios.post(createApiServerRoute('fetch_withdraw_request.php'), params, config)
            .then(res => {
                if (res.data.state === 'OK') {
                    const data = res.data.data['withdraw_requests_meta'] || [];
                    const sorted = data.sort((b, a) => new Date(a.created_at) - new Date(b.created_at));
                    this.setState({
                        type: status,
                        filtered: sorted,
                        page: res.data.data.currentPage || 1,
                        totalPages: res.data.data.totalPages || 1
                    });
                }
            }).catch(err => {
                console.error("Failed to fetch withdraw requests", err);
            });
    };

    ApproveRequest = (uid) => {
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY);
        params.append("withdraw_request_uid", uid);

        axios.post(createApiServerRoute('approve_user_withdraw_request.php'), params)
            .then(res => {
                if (res.data.state === 'OK' && res.data.data.approved) {
                    this.setState(prevState => ({
                        filtered: prevState.filtered.filter(f => f['uid'] !== uid)
                    }));
                }
            });
    };

    CancelRequest = (uid) => {
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY);
        params.append("withdraw_request_uid", uid);

        axios.post(createApiServerRoute('cancel_user_withdraw_request.php'), params)
            .then(res => {
                if (res.data.state === 'OK' && res.data.data.cancelled) {
                    this.setState(prevState => ({
                        filtered: prevState.filtered.filter(f => f['uid'] !== uid)
                    }));
                }
            });
    };

    handleTabChange = (e) => {
        const selectedType = e.target.value;
        this.fetchWithdrawRequests(selectedType, 1); // reset to page 1
    };

    handleNextPage = () => {
        const { page, type } = this.state;
        this.fetchWithdrawRequests(type, page + 1);
    };

    handlePreviousPage = () => {
        const { page, type } = this.state;
        if (page > 1) {
            this.fetchWithdrawRequests(type, page - 1);
        }
    };

    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        const { filtered, type, filter, page } = this.state;

        const filteredData = (filtered || []).filter(f =>
            !filter || f['phone']?.includes(filter) || f['name']?.toLowerCase().includes(filter.toLowerCase())
        );

        return (
            <>
                <center>
                    <FormControl>
                    <FormLabel
  style={{
    margin: '16px 0',
    fontSize: '20px',
    fontWeight: '600',
  }}
>
  Withdraw Requests
</FormLabel>

                        <RadioGroup
                            defaultValue="PENDING"
                            row
                            onChange={this.handleTabChange}
                        >
                  
                  <div
  style={{
    display: 'flex',
    flexDirection: 'row',
    gap: '12px', // gap between buttons
    marginTop: '16px',
    marginBottom: '16px',
  }}
>
    
  <FormControlLabel
    value="PENDING"
    control={
      <Radio
        style={{
          color: '#fff', // primary blue
        }}
      />
    }
    
    label={
        <span style={{ color: '#fff' }}>Pending</span> // 🔥 Font color change here
      }
    style={{
      backgroundColor: '#00b894',
      padding: '10px 20px',
      borderRadius: '8px',
      fontWeight: 'bold',
      boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    }}
  />

  <FormControlLabel
    value="CANCEL"
    control={
      <Radio
        style={{
          color: '#fff', // red
        }}
      />
    }
   
    label={
        <span style={{ color: '#fff' }}>Cancel</span> // 🔥 Font color change here
      }
    style={{
      backgroundColor: '#ff7675',
      padding: '10px 20px',
      borderRadius: '8px',
      fontWeight: 'bold',
      boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    }}
  />

  <FormControlLabel
    value="APPROVE"
    control={
      <Radio
        style={{
          color: '#fff', // green
        }}
      />
    }
    label={
        <span style={{ color: '#fff' }}>Approve</span> // 🔥 Font color change here
      }
    style={{
      backgroundColor: '#0984e3',
      padding: '10px 20px',
      borderRadius: '8px',
      fontWeight: 'bold',
      boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    }}
  />
</div>

                        </RadioGroup>
                    </FormControl>
                </center>

                <div className="flex flex-col">
                    <input
                        type="text"
                        value={filter}
                        onChange={e => this.setState({ filter: e.target.value })}
                        className="mx-8 px-8 py-2 rounded-2xl mb-6 placeholder-indigo-600 outline-none placeholder-opacity-50"
                        placeholder="Enter the number..."
                    />

                    <Table>
                        <TableHeader>
                            <TableHeading>#</TableHeading>
                            <TableHeading>Username</TableHeading>
                            <TableHeading>Phone</TableHeading>
                            <TableHeading>Amount</TableHeading>
                            <TableHeading>Account Details</TableHeading>
                            <TableHeading>Date</TableHeading>
                            {type === "PENDING" && user?.type === 'MAIN' && <TableHeading>Status</TableHeading>}
                        </TableHeader>

                        <TableBody>
                            {filteredData.map((f, index) => (
                                <tr key={f['uid']}>
                                    <TableIndexColumn num={index + 1 + ((page - 1) * 10)} />
                                    <TableUserNameColumn
                                        avatarUrl={f['avatar']}
                                        firstName={f['name']}
                                        lastName=""
                                        email={f['email']}
                                    />
                                    
                                    <TableGreenishTextualColumn
                                        text={f['phone']}
                                        clickListener={() => window.open("https://wa.me/" + f['phone'], "_blank")}
                                    />
                                    <TableTextualColumn text={f['amount']} />
                                    <TableBankColumn
                                        upperName={f['bank_name']}
                                        lowerName={f['bank_account_number']}
                                    />
                                    <TableTextualColumn text={f['created_at']} />
                                    {type === "PENDING" && user?.type === "MAIN" && (
                                       <TableContainerColumn>
                                       <ButtonGroup
                                         orientation="horizontal"
                                         variant="contained"
                                         style={{ gap: '40px', boxShadow:'none' }}
                                       >
                                         <Button
                                           color="primary"
                                           onClick={() => this.ApproveRequest(f['uid'])}
                                         >
                                           Approve
                                         </Button>
                                         <Button
                                           color="secondary"
                                           onClick={() => this.CancelRequest(f['uid'])}
                                         >
                                           Cancel
                                         </Button>
                                       </ButtonGroup>
                                     </TableContainerColumn>
                                     
                                    )}
                                </tr>
                            ))}
                        </TableBody>
                    </Table>

                    <div className="flex justify-center items-center mt-6 gap-4">
    <Button
        variant="contained"
        onClick={this.handlePreviousPage}
        disabled={page === 1}
    >
        Previous
    </Button>

    <span className="font-semibold">
        Page {page} of {this.state.totalPages}
    </span>

    <Button
        variant="contained"
        onClick={this.handleNextPage}
        disabled={page >= this.state.totalPages}
    >
        Next
    </Button>
</div>

                </div>
            </>
        );
    }
}

// ... mapStateToProps & export (unchanged)


const mapStateToProps = rootReducer => ({
    clients: rootReducer.clients.currentClients
});

const mapDispatchToProps = dispatch => ({
    actionSetCurrentClients: clients => dispatch(actionSetCurrentClients(clients))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UsersFragment));
